module.exports = __webpack_public_path__ + "static/media/06_insideyourblood.74dd63f6.jpg";